import { render, staticRenderFns } from "./com-prodserv.vue?vue&type=template&id=8f887a82&scoped=true&"
import script from "./com-prodserv.vue?vue&type=script&lang=js&"
export * from "./com-prodserv.vue?vue&type=script&lang=js&"
import style0 from "./com-prodserv.vue?vue&type=style&index=0&id=8f887a82&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f887a82",
  null
  
)

export default component.exports